/* POGS: Header ikon renk override — anasayfa transparent header */
(function() {
  if (!document.body.classList.contains('template-index')) return;
  if (document.getElementById('pogs-header-color-style')) return;
  var s = document.createElement('style');
  s.id = 'pogs-header-color-style';
  s.textContent = [
    'body.template-index .theme__header .navlink{color:#111!important}',
    'body.template-index .theme__header .header__desktop__button a{color:#111!important}',
    'body.template-index .theme__header .header__mobile__right a{color:#111!important}',
    'body.template-index .theme__header .header__mobile__right button{color:#111!important}',
    'body.template-index .theme__header .header__cart__status{color:#111!important}'
  ].join('');
  document.head.appendChild(s);
})();

/* POGS — Zara-style side-sliding mega menu (click-to-open, multi-level) */
(function () {
  if (window.__pogsZaraMenuInit) return;
  window.__pogsZaraMenuInit = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    const dataEl = document.getElementById('pogs-zara-menu-data');
    const root = document.getElementById('pogs-zara-menu');
    if (!dataEl || !root) return;

    let menu;
    try { menu = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!menu || !Array.isArray(menu.items) || menu.items.length === 0) return;

    const stack = root.querySelector('.pogs-zara-stack');
    const backBtn = root.querySelector('[data-pogs-back]');
    const closeEls = root.querySelectorAll('[data-pogs-close]');

    // Build levels: level 0 = root, level 1 = active top item, level 2 = active second item
    const levelStack = []; // array of {title, items, parentItem}
    let activeIndex = 0;

    function renderLevel(levelData) {
      const div = document.createElement('div');
      div.className = 'pogs-zara-level';
      // "Anasayfa" link in every level (including root) — always available
      const home = document.createElement('a');
      home.href = '/';
      home.className = 'pogs-zara-home';
      home.textContent = 'Anasayfa';
      div.appendChild(home);
      if (levelData.heading) {
        const h = document.createElement('div');
        h.className = 'pogs-zara-section-head';
        h.textContent = levelData.heading;
        div.appendChild(h);
      }
      levelData.items.forEach((it) => {
        const hasChildren = it.items && it.items.length > 0;
        if (hasChildren) {
          // Two buttons: one to navigate (chevron), and one direct link via title? Simpler: single button that opens deeper level
          // Add an extra "Tümünü gör" leaf link at top if a URL exists
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pogs-zara-item' + (levelData.level === 0 ? ' pogs-zara-item--top' : '');
          btn.innerHTML = `<span>${escapeHtml(it.title)}</span><span class="pogs-zara-chevron">›</span>`;
          btn.addEventListener('click', () => pushLevel(it));
          div.appendChild(btn);
        } else {
          const a = document.createElement('a');
          a.href = it.url || '#';
          a.className = 'pogs-zara-item pogs-zara-item--leaf' + (levelData.level === 0 ? ' pogs-zara-item--top' : '');
          a.innerHTML = `<span>${escapeHtml(it.title)}</span>`;
          div.appendChild(a);
        }
      });
      // For non-root levels with a URL, prepend "Tümünü gör" link
      if (levelData.level > 0 && levelData.parentItem && levelData.parentItem.url) {
        const a = document.createElement('a');
        a.href = levelData.parentItem.url;
        a.className = 'pogs-zara-item pogs-zara-item--leaf';
        a.innerHTML = `<span>Tümünü gör</span>`;
        // Insert below heading
        div.insertBefore(a, div.children[1] || null);
      }
      return div;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]);
    }

    function pushLevel(item) {
      const lvl = {
        level: levelStack.length + 1,
        heading: item.title,
        items: item.items,
        parentItem: item,
      };
      levelStack.push(lvl);
      const el = renderLevel(lvl);
      stack.appendChild(el);
      // Trigger transition
      requestAnimationFrame(() => {
        // Mark previous as past
        const prev = stack.querySelectorAll('.pogs-zara-level');
        prev.forEach((p, i) => {
          p.classList.remove('is-active');
          if (i === prev.length - 1) p.classList.add('is-active');
          else if (i === prev.length - 2) p.classList.add('is-past');
        });
      });
      updateBackButton();
    }

    function popLevel() {
      if (levelStack.length === 0) return;
      const last = stack.lastElementChild;
      if (last) last.classList.remove('is-active');
      // After transition end, remove
      setTimeout(() => last && last.remove(), 320);
      levelStack.pop();
      // Mark new last as active
      const levels = stack.querySelectorAll('.pogs-zara-level');
      const newActive = levels[levels.length - 2]; // because last is being removed
      if (newActive) {
        newActive.classList.remove('is-past');
        newActive.classList.add('is-active');
      }
      updateBackButton();
    }

    function updateBackButton() {
      if (levelStack.length > 0) backBtn.removeAttribute('hidden');
      else backBtn.setAttribute('hidden', '');
    }

    function open(topIndex) {
      // Reset all levels first
      stack.querySelectorAll('.pogs-zara-level').forEach((el) => el.remove());
      levelStack.length = 0;
      // Render root level
      const rootLvl = { level: 0, items: menu.items };
      const rootEl = renderLevel(rootLvl);
      rootEl.classList.add('is-active');
      stack.appendChild(rootEl);
      // If specific top index requested, drill in
      if (typeof topIndex === 'number' && menu.items[topIndex] && menu.items[topIndex].items.length > 0) {
        setTimeout(() => pushLevel(menu.items[topIndex]), 20);
      }
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Clear levels after animation
      setTimeout(() => {
        stack.querySelectorAll('.pogs-zara-level').forEach((el) => el.remove());
        levelStack.length = 0;
        updateBackButton();
      }, 320);
    }

    backBtn.addEventListener('click', popLevel);
    closeEls.forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // Bind our own hamburger trigger (top-left) — opens root level of the panel
    const trigger = document.getElementById('pogs-zara-trigger');
    if (trigger) {
      trigger.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        open();
      });
    }

    // Add is-scrolled class to body once page is scrolled — header turns opaque on homepage
    function updateScrolled() {
      if (window.scrollY > 40) document.body.classList.add('is-scrolled');
      else document.body.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', updateScrolled, { passive: true });
    updateScrolled();

    // === Predictive search ===
    const searchForm  = root.querySelector('.pogs-zara-search');
    const searchInput = root.querySelector('.pogs-zara-search-input');
    const searchClear = root.querySelector('[data-pogs-search-clear]');
    const suggBox     = root.querySelector('[data-pogs-suggestions]');
    const stackEl     = root.querySelector('.pogs-zara-stack');
    let searchTimer = 0;

    function showSuggestions(show) {
      if (show) {
        suggBox.hidden = false;
        stackEl.style.display = 'none';
      } else {
        suggBox.hidden = true;
        stackEl.style.display = '';
      }
    }

    function fmtMoney(cents) {
      const v = (Number(cents) / 100).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      return v + ' TL';
    }

    async function runSearch(q) {
      if (!q || q.length < 2) { showSuggestions(false); return; }
      try {
        const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6');
        const d = await r.json();
        const products = d?.resources?.results?.products || [];
        if (products.length === 0) {
          suggBox.innerHTML = '<div class="pogs-zara-sugg-empty">"' + escapeHtml(q) + '" için sonuç bulunamadı</div>';
        } else {
          let html = '';
          for (const p of products) {
            const img = p.featured_image?.url || p.image || '';
            const price = p.price ? fmtMoney(p.price) : '';
            html += '<a class="pogs-zara-sugg-item" href="' + p.url + '">';
            if (img) html += '<img class="pogs-zara-sugg-thumb" src="' + img + '" alt="" loading="lazy"/>';
            else html += '<span class="pogs-zara-sugg-thumb"></span>';
            html += '<span class="pogs-zara-sugg-body">';
            html += '<span class="pogs-zara-sugg-title">' + escapeHtml(p.title) + '</span>';
            if (price) html += '<span class="pogs-zara-sugg-price">' + price + '</span>';
            html += '</span></a>';
          }
          html += '<a class="pogs-zara-sugg-all" href="/search?q=' + encodeURIComponent(q) + '">Tüm sonuçları gör</a>';
          suggBox.innerHTML = html;
        }
        showSuggestions(true);
      } catch (e) {
        // Fail silently — form submit fallback will navigate to /search
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', (ev) => {
        const q = ev.target.value.trim();
        searchClear.hidden = q.length === 0;
        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => runSearch(q), 200);
      });
      searchClear.addEventListener('click', () => {
        searchInput.value = '';
        searchClear.hidden = true;
        showSuggestions(false);
        searchInput.focus();
      });
      // When drawer is opened, focus search after a beat
      const observer = new MutationObserver(() => {
        if (root.classList.contains('is-open')) {
          setTimeout(() => searchInput.focus(), 350);
        } else {
          // Clear when closed
          searchInput.value = '';
          searchClear.hidden = true;
          showSuggestions(false);
        }
      });
      observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    }
  });
})();


/* POGS Hero video cover: ilk kare flash'ı gizle */
(function() {
  function initHeroCover() {
    var vid = document.getElementById('pogs-hero-video-el');
    if (!vid) return;
    var frame = vid.closest('.pogs-hero-video-frame');
    if (!frame) return;

    // Cover div yoksa oluştur
    var cvr = frame.querySelector('.pogs-hero-video-cover');
    if (!cvr) {
      cvr = document.createElement('div');
      cvr.className = 'pogs-hero-video-cover';
      cvr.setAttribute('aria-hidden', 'true');
      vid.after(cvr);
    }

    // CSS'i head'e enjekte et (zaten pogs-zara-menu.css'de varsa iki kez eklenmez)
    if (!document.getElementById('pogs-cover-style')) {
      var s = document.createElement('style');
      s.id = 'pogs-cover-style';
      s.textContent = '.pogs-hero-video-cover{position:absolute;inset:0;background:#0d0d0d;z-index:4;pointer-events:none;opacity:1;transition:opacity .45s ease}.pogs-hero-video-cover.is-playing{opacity:0}';
      document.head.appendChild(s);
    }

    function reveal() { cvr.classList.add('is-playing'); }
    if (vid.readyState >= 3) { reveal(); return; }
    vid.addEventListener('playing', reveal, { once: true });
    vid.addEventListener('canplay', reveal, { once: true });
    setTimeout(reveal, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroCover);
  } else {
    initHeroCover();
  }
})();
/* POGS Logo kısalma fix — JS ile anında uygula */
(function() {
  function fixLogo() {
    var links = document.querySelectorAll('.header__logo__link');
    var texts = document.querySelectorAll('.header__logo__text');
    var spans = document.querySelectorAll('.header__logo__text span');
    links.forEach(function(link) {
      link.style.removeProperty('--LOGO-WIDTH');
      link.style.width = 'auto';
      link.style.maxWidth = 'none';
      link.style.overflow = 'visible';
    });
    texts.forEach(function(text) {
      text.style.whiteSpace = 'nowrap';
      text.style.overflow = 'visible';
      text.style.padding = '0 10px';
    });
    spans.forEach(function(span) {
      span.style.whiteSpace = 'nowrap';
      span.style.maxWidth = 'none';
      span.style.overflow = 'visible';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixLogo);
  } else {
    fixLogo();
  }
})();
